module.exports = __webpack_public_path__ + "static/omni-8ff8b3dc40ac1bf3d6a9208b1ed53e58.png";